import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Mail, Shield } from '../utils/icons';
import { useI18n } from '../i18n';

const NotFound = () => {
  const { t } = useI18n();

  return (
    <div className="min-h-screen bg-gray-50 pt-20 flex items-center">
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="mx-auto max-w-3xl rounded-2xl bg-white p-10 text-center shadow-xl"
        >
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-100 text-blue-700">
            <Shield className="h-10 w-10" />
          </div>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700">404</p>
          <h1 className="mt-3 text-4xl font-extrabold text-gray-900 md:text-5xl">{t('notFound.title')}</h1>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-gray-600">{t('notFound.subtitle')}</p>

          <div className="mt-8 flex flex-col justify-center gap-4 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-700 px-6 py-3 font-semibold text-white transition hover:bg-blue-800"
            >
              <Home className="h-5 w-5" />
              {t('notFound.home')}
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-6 py-3 font-semibold text-blue-800 transition hover:bg-blue-100"
            >
              <Shield className="h-5 w-5" />
              {t('notFound.services')}
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 px-6 py-3 font-semibold text-gray-700 transition hover:border-green-400 hover:text-green-600"
            >
              <Mail className="h-5 w-5" />
              {t('notFound.contact')}
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
